<template>
    <div>
        <TableErrorKRA v-if="tableError" :responseError="listErrors"/>

        <div v-if="!tableError" style="display: flex; flex-direction: column; gap: 20px">
          <div style="display: flex; flex-direction: column">
            <el-select v-model="isChangeKraDefault" placeholder="chọn cách import kra" style="width: 250px">
              <el-option
                  v-for="item in isChangeKraDefaultOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled">
              </el-option>
            </el-select>
          </div>
          <div style="display: flex; flex-direction: column" v-if="!isChangeKraDefault">
            <label>Chọn tháng</label>
            <el-date-picker
              v-model="selectedMonth"
              type="month"
              placeholder="Chọn tháng"
              format="MM/yyyy"
              value-format="MM/yyyy"
              :picker-options="monthPickerOptions"
            />
          </div>

            <div style="display: flex; flex-direction: column" class="mt-3">
                <label>Bước 1: Tải xuống file mẫu</label>
                <button class="btn btn-primary" style="width: 130px" @click="downloadFileExcelExample">
                    <i class="el-icon-bottom" style="color: white"></i>
                    Tải xuống
                </button>
            </div>

            <div style="display: flex; flex-direction: column">
                <label>Bước 2: Tải file excel lên hệ thống</label>
                <div v-if="fileImport" style="display: flex; align-items: center; gap: 8px">
                    <span>{{ fileImport.name }}</span>
                    <el-button class="btn-remove" type="text" @click="fileImport = null">
                        <i class="el-icon-delete" style="color: red !important;"></i>
                    </el-button>
                </div>
                <label v-else class="btn btn-warning" for="upload-file" style="width: 130px">
                    <input id="upload-file" accept=".xlsx, .xls" style="display: none" type="file"
                           @change="handleFileUpload"/>
                    <i class="el-icon-top" style="color: white"></i>
                    Tải lên
                </label>
            </div>
        </div>
        <div style="display: flex;justify-content: flex-end; align-items: center; gap: 20px">
            <button class="btn" style="background: #CACACA" @click="closeDialog">Hủy bỏ</button>
            <el-button v-if="!tableError" v-loading="disableImport" :disabled="disableImport"
                       class="btn btn-primary text-white" style="background: #5D04B0" @click="handleImportFileExcel">Xác
                nhận
            </el-button>
            <button
                v-if="tableError"
                class="btn btn-primary text-white"
                style="background: #5D04B0"
                @click="backToImport"
            >Quay lại
            </button>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import {IMPORT_FILE_EXCEL_KRA, PREVIEW_FILE_EXCEL_KRA} from "@/core/services/store/user/users.module";
import {ImportKraModel} from "@/view/pages/user/model/ImportKraModel";
import TableErrorKRA from "@/view/pages/user/Component/TableErrorKRA.vue";

export default {
    name: "DialogImportKRA",
    components: {TableErrorKRA},
    data() {
      const now = new Date()
        return {
            fileImport: null,
            dataImport: [],
            tableError: false,
            listErrors: [],
            disableImport: false,
            isChangeKraDefault: true,
            isChangeKraDefaultOptions: [
              { label: 'Import KRA mặc đinh', value: true, disabled: false },
              { label: 'Import KRA theo tháng', value: false, disabled: false }
            ],
            selectedMonth: `${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()}`,
            monthPickerOptions: {
              disabledDate(date) {
                const currentMonth = new Date(
                    now.getFullYear(),
                    now.getMonth() + 1,
                    1
                )

                return date.getTime() >= currentMonth.getTime()
              }
            }
        }
    },
    mounted() {
    },
    methods: {
        downloadFileExcelExample() {
            const filePath = process.env.BASE_URL + 'excel/File mẫu import kra.xlsx';
            const a = document.createElement('a');
            a.href = filePath;
            a.download = 'File mẫu import kra.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.fileImport = file
                this.readExcelFile(file);
            }
        },
        closeDialog() {
            this.$emit('closeDialog');
            this.$emit('setTitleError', 'Import kra')
            this.listErrors = []
            this.fileImport = null
            this.tableError = false
            this.disableImport = false
        },
        readExcelFile(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, {type: 'array'});
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1});
                const columnMapping = {
                    "Mã nhân sự": 'ma_nhan_su',
                    "Vị trí": 'vi_tri',
                    "ID đơn vị": 'id_don_vi',
                    "KRA": 'kra',
                    "Yêu cầu thành phẩm": 'yeu_cau_thanh_pham',
                    "Số giờ": 'so_gio',
                    "Trọng số": 'trong_so'
                }
                const headers = jsonData[0];
                const rows = jsonData.slice(1);
                const translatedHeaders = headers.map(header => columnMapping[header] || header);
                let totalTime = 0;
                const indexTime = Object.keys(columnMapping).indexOf("Số giờ");
                const indexRatio = Object.keys(columnMapping).indexOf("Trọng số");
                rows.filter(item => item.length > 0).map(row => {
                    totalTime += row[indexTime] ?? 0
                })
                const calc = this.createPercentageCalculator(totalTime);
                this.dataImport = rows.filter(item => item.length > 0).map((row, i) => {
                    const obj = {};
                    const isLast = i === rows.filter(item => item.length > 0).length - 1;
                    translatedHeaders.forEach((header, index) => {
                        obj[header] = row[index] !== undefined && row[index] !== null ? row[index] : null;
                        if (index === indexRatio) {
                            obj[header] = calc(row[indexTime], isLast)
                        }
                    });
                    return obj;
                })
            };
            reader.readAsArrayBuffer(file);
        },
        createPercentageCalculator(total, decimalPlaces = 2) {
            const factor = Math.pow(10, decimalPlaces);
            let sumRounded = 0;
            let sumRaw = 0;
            let count = 0;
            return function(value, isLast = false) {
                const raw = (value / total) * 100;
                sumRaw += raw;
                let rounded = Math.round(raw * factor) / factor;
                sumRounded += rounded;
                count++;
                if (isLast) {
                    const diff = Math.round((100 - sumRounded) * factor) / factor;
                    rounded += diff;
                    sumRounded += diff;
                }
                return rounded;
            };
        },
        backToImport() {
            this.fileImport = null
            this.tableError = false
            this.disableImport = false
            this.listErrors = []
            this.$emit('setTitleError', 'Import kra')
        },

      async handleImportFileExcel() {
        this.disableImport = true;

        // 1. Kiểm tra file
        if (!this.fileImport) {
          this.$notify({ title: 'Thất bại', message: 'Chưa có file nào được chọn', type: 'error' });
          this.disableImport = false;
          return;
        }
        if (this.dataImport.length === 0) {
          this.$message.warning('Bạn không thể import khi file excel không có bản ghi nào');
          this.disableImport = false;
          return;
        }

        const groups = this.dataImport.reduce((acc, row) => {
          const key = `${row.ma_nhan_su}|${row.vi_tri}|${row.id_don_vi}`;
          if (!acc[key]) acc[key] = [];
          acc[key].push(row);
          return acc;
        }, {});

        const allErrors = [];

        for (const [key, group] of Object.entries(groups)) {
          const totalHours = group.reduce((sum, r) => sum + (r.so_gio || 0), 0);
          const calc = this.createPercentageCalculator(totalHours);
          const payload = group.map((r, idx, arr) => ({
            ...r,
            trong_so: calc(r.so_gio, idx === arr.length - 1)
          }));

          const res = await this.$store.dispatch(PREVIEW_FILE_EXCEL_KRA, payload);
          const errs = res?.data?.flatMap((item, i) => {
            if (item.errors && Object.values(item.errors).length) {
              return new ImportKraModel(
                  i + 1,
                  item.ma_nhan_su,
                  item.vi_tri,
                  item.id_don_vi,
                  item.kra,
                  item.yeu_cau_thanh_pham,
                  item.so_gio,
                  item.trong_so,
                  item.errors
              );
            }
            return [];
          });
          allErrors.push(...errs);

          groups[key] = payload;
        }

        if (allErrors.length) {
          this.listErrors = allErrors;
          this.tableError = true;
          this.$emit('setTitleError', 'Báo lỗi');
          this.disableImport = false;
          return;
        }

        for (const payload of Object.values(groups)) {
          await this.$store.dispatch(IMPORT_FILE_EXCEL_KRA, {
            data: payload,
            month: this.isChangeKraDefault ? '' : this.selectedMonth,
            isChangeKraDefault: this.isChangeKraDefault
          });
        }

        this.$message.success('Import thành công');
        this.closeDialog();
      }

    }
}
</script>